import * as EmailValidator from 'email-validator';

export function validate(email) {
  return EmailValidator.validate(email);
}

export default {
  validate
}